"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPayloadFromRequest = exports.getCorrelationIdFromHeaders = exports.getUserFromHeaders = exports.setUserFromContext = exports.setCorrelationId = exports.correlationId = exports.userRolesHeader = exports.userIsAdminHeader = exports.userIdentHeader = exports.userDealerNameHeader = exports.userDealerIdHeader = exports.userFullNameHeader = exports.userEmailHeader = exports.userTypeHeader = exports.userIdHeader = void 0;
// @ts-ignore
const uuid_1 = require("uuid");
exports.userIdHeader = 'user-id';
exports.userTypeHeader = 'user-type';
exports.userEmailHeader = 'user-email';
exports.userFullNameHeader = 'user-name';
exports.userDealerIdHeader = 'user-dealer-id';
exports.userDealerNameHeader = 'user-dealer-name';
exports.userIdentHeader = 'user-ident';
exports.userIsAdminHeader = 'user-is-admin';
exports.userRolesHeader = 'user-roles';
exports.correlationId = 'x-request-id';
const setCorrelationId = (request, context) => {
    if (!context.headers) {
        context.headers = {};
    }
    const reqId = context.headers.hasOwnProperty(exports.correlationId) ? context.headers[exports.correlationId] : (0, uuid_1.v4)();
    context.headers[exports.correlationId] = reqId;
    request.http.headers.set(exports.correlationId, reqId);
};
exports.setCorrelationId = setCorrelationId;
const setUserFromContext = (request, context) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    const userId = ((_a = context === null || context === void 0 ? void 0 : context.user) === null || _a === void 0 ? void 0 : _a.id) || null;
    const userType = ((_b = context === null || context === void 0 ? void 0 : context.user) === null || _b === void 0 ? void 0 : _b.type) || null;
    const userEmail = ((_c = context === null || context === void 0 ? void 0 : context.user) === null || _c === void 0 ? void 0 : _c.email) || null;
    const userName = ((_d = context === null || context === void 0 ? void 0 : context.user) === null || _d === void 0 ? void 0 : _d.fullName) || null;
    const userDealerId = ((_e = context === null || context === void 0 ? void 0 : context.user) === null || _e === void 0 ? void 0 : _e.dealerId) || null;
    const userDealerName = ((_f = context === null || context === void 0 ? void 0 : context.user) === null || _f === void 0 ? void 0 : _f.dealerName) || null;
    const userIdent = ((_g = context === null || context === void 0 ? void 0 : context.user) === null || _g === void 0 ? void 0 : _g.ident) || null;
    const userIsAdmin = ((_h = context === null || context === void 0 ? void 0 : context.user) === null || _h === void 0 ? void 0 : _h.isAdmin) || false;
    const userRoles = ((_j = context === null || context === void 0 ? void 0 : context.user) === null || _j === void 0 ? void 0 : _j.roles) || [];
    request.http.headers.set(exports.userIdHeader, userId);
    request.http.headers.set(exports.userTypeHeader, userType);
    request.http.headers.set(exports.userEmailHeader, userEmail);
    request.http.headers.set(exports.userFullNameHeader, userName);
    request.http.headers.set(exports.userDealerIdHeader, userDealerId);
    request.http.headers.set(exports.userDealerNameHeader, userDealerName);
    request.http.headers.set(exports.userIdentHeader, userIdent);
    request.http.headers.set(exports.userIsAdminHeader, userIsAdmin);
    request.http.headers.set(exports.userRolesHeader, userRoles);
};
exports.setUserFromContext = setUserFromContext;
const getRoles = (headers) => {
    const rolesString = headers.hasOwnProperty(exports.userRolesHeader) ? headers[exports.userRolesHeader] : '';
    return rolesString ? rolesString.split(',').map((x) => parseInt(x, 10)) : [];
};
const getUserFromHeaders = (request) => {
    if (!request || !request.headers)
        return null;
    const headers = request.headers;
    return {
        id: headers.hasOwnProperty(exports.userIdHeader) ? headers[exports.userIdHeader] : null,
        email: headers.hasOwnProperty(exports.userEmailHeader) ? headers[exports.userEmailHeader] : null,
        type: headers.hasOwnProperty(exports.userTypeHeader) ? headers[exports.userTypeHeader] : null,
        fullName: headers.hasOwnProperty(exports.userFullNameHeader) ? headers[exports.userFullNameHeader] : null,
        dealerId: headers.hasOwnProperty(exports.userDealerIdHeader) ? headers[exports.userDealerIdHeader] : null,
        dealerName: headers.hasOwnProperty(exports.userDealerNameHeader) ? headers[exports.userDealerNameHeader] : null,
        ident: headers.hasOwnProperty(exports.userIdentHeader) ? headers[exports.userIdentHeader] : null,
        isAdmin: headers.hasOwnProperty(exports.userIsAdminHeader) ? headers[exports.userIsAdminHeader] : null,
        roles: getRoles(headers),
    };
};
exports.getUserFromHeaders = getUserFromHeaders;
const getCorrelationIdFromHeaders = (request) => {
    if (!request || !request.headers)
        return { correlationId: (0, uuid_1.v4)() };
    const headers = request.headers;
    return { correlationId: headers.hasOwnProperty(exports.correlationId) ? headers[exports.correlationId] : (0, uuid_1.v4)() };
};
exports.getCorrelationIdFromHeaders = getCorrelationIdFromHeaders;
const nthIndex = (str, pattern, n) => {
    let L = str.length, i = -1;
    while (n-- && i++ < L) {
        i = str.indexOf(pattern, i);
        if (i < 0)
            break;
    }
    return i;
};
const getPayloadFromRequest = (request) => {
    if (!(request === null || request === void 0 ? void 0 : request.payload))
        return '';
    const index = nthIndex(request.payload, '{', 2);
    return request.payload.substring(index + 1, request.payload - 2).trim();
};
exports.getPayloadFromRequest = getPayloadFromRequest;
//# sourceMappingURL=back-end.js.map